import { render, staticRenderFns } from "./SesoAlert.vue?vue&type=template&id=b1ef87ac&scoped=true&"
import script from "./SesoAlert.vue?vue&type=script&lang=js&"
export * from "./SesoAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ef87ac",
  null
  
)

export default component.exports